import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

import { LOGIN_SUCCESS_MESSAGE } from '../../hooks/oauthHook';
import { checkOpenerSameOrigin } from '../../utils';

/**
 * Share To Patient Preview 페이지나 QR Code Preview 페이지에서
 * 새 창으로 로그인하거나 회원가입할 때 성공 이후 redirect 로 지정되는 페이지
 *
 * 되어야 하는 것:
 *
 * 로그인하지 않았을 때 email 회원으로 가입할 때
 * - Preview 페이지에서 로그인 버튼 -> 로그인 -> 꺼짐
 * - Preview 페이지에서 로그인 버튼 -> 로그인 페이지에서 회원가입 버튼 -> 회원가입 -> 받은 이메일에서 본인 인증 링크 클릭 -> Preview 페이지로
 * - Preview 페이지에서 회원가입 버튼 -> 회원가입 -> Preview 페이지로
 * - Preview 페이지에서 Save images 버튼 -> 로그인 -> 꺼짐
 * - Preview 페이지에서 Save images 버튼 -> 로그인 페이지에서 회원가입 버튼 -> 회원가입 -> 받은 이메일에서 본인 인증 링크 클릭 -> Preview 페이지로
 */
export const AutoClosePage = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirectUrl');
  const navigate = useNavigate();

  useEffect(() => {
    if (checkOpenerSameOrigin()) {
      if (window.opener) {
        window.opener.postMessage(LOGIN_SUCCESS_MESSAGE, '*');
      }
      window.close();
      window.addEventListener('load', window.close);
    } else {
      if (redirectUrl) {
        console.log('navigate');
        navigate(redirectUrl, { replace: true });
      }
    }
  }, [navigate, redirectUrl]);

  return <div>{t('closeThisWindow')}</div>;
};
